import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValueSet, LocalService, PageKey, RelationShipRole, Wrappers5 } from '../../../service/local.service';

@Component({
  selector: 'app-payment-gateway',
  templateUrl: './payment-gateway.component.html',
  styleUrls: ['./payment-gateway.component.scss']
})
export class PaymentGatewayComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["prepaid_gateway"];
  wrapper: Wrappers5; maxBodyHeight = 0; paidTypes: KeyValueSet[]; paymentGatewayStatuses: KeyValueSet[];
  ctryCode: string = ''; userId: string = ''; businessId: string = ''; interactionType: InteractionType;
  RelationShipRole = RelationShipRole;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.PaidType).subscribe(result => {
      this.paidTypes = result;
    });
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.PaymentGatewayStatus).subscribe(result => {
      this.paymentGatewayStatuses = result;
    });
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.User)
        this.businessId = this.userId;
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.PaymentGatewayBusiness, this.businessId);
      else if (this.interactionType == InteractionType.ServiceProvider)
        this.configurationManagementService.ensurePageActions(PageKey.PaymentGatewayServiceProvider);
      else
        this.configurationManagementService.ensurePageActions(PageKey.None);
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(40);
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.configurationManagementService.getPaymentsGateway(this.businessId, this.interactionType, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
        this.wrapper = result;
      });
    }
  }
}
